import React from 'react'
import { HelmetProvider, Helmet } from 'react-helmet-async';
import { Tooltip as ReactTooltip } from "react-tooltip";

import TopBanner from '../components/TopBanner';
import RightImageText from '../components/RightImageText';
import Badge from '../components/Badge';
import BestSolutions from '../components/BestSolutions';
// import Solutions from '../components/Solutions';

export default function OurServices() {
    const homeimg = '/images/home/home.jpg'; // Path to image in public folder
    const server_url = process.env.REACT_APP_SERVER;

    const schemaData = {
        "@context": "https://schema.org",
        "@type": "Service",
        "serviceType": "IT Solutions",
        "provider": {
          "@type": "Organization",
          "name": "Lurantech",
          "url": `${server_url}`,
          "logo": `${server_url}/images/logo.png`,
          "contactPoint": {
            "@type": "ContactPoint",
            "telephone": "+91-7226-999-101",
            "contactType": "Customer Service",
            "areaServed": "IN",
            "availableLanguage": "English"
          },
          "sameAs": [
            "https://www.facebook.com/Lurantech-107968334690860",
            "https://www.linkedin.com/company/lurantech",
            "https://x.com/lurantech"
          ],
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "FF-401, 4th Floor, 7 Sky Complex, Laxmipura, Near VUDA Cross Road",
            "addressLocality": "Vadodara",
            "addressRegion": "Gujarat",
            "postalCode": "390021",
            "addressCountry": "IN"
          }
        },
        "description": "Lurantech offers tailored IT solutions to help your business succeed. Our services include Liferay CMS development, IT service management, cloud solutions, data engineering, application development, and more. We prioritize quality and flexibility in every project.",
        "serviceAudience": {
          "@type": "Audience",
          "audienceType": "Business Clients"
        },
        "offers": [
          {
            "@type": "Offer",
            "priceCurrency": "INR",
            "price": "Contact for pricing",
            "eligibleRegion": {
              "@type": "Place",
              "name": "India"
            },
            "url": `${server_url}/service`
          }
        ]
    }

    return (
        <>
            <HelmetProvider>
                <Helmet>
                    <meta property="og:title" content="Lurantech | Services | Tailored IT Solutions for Your Success" />
                    <meta property="og:description" content="Lurantech offers top-quality IT services like Liferay CMS development, IT service management, cloud solutions, data engineering, and more. Tailored IT solutions for you." />
                    <meta property="og:image" content={`${server_url}${homeimg}`} />
                    <meta property="og:url" content={`${server_url}/service`} />
                    <meta property="og:type" content="website" />
                    <meta property="og:image:type" content="image/jpeg" />
                    <meta property="og:image:width" content="1200" />
                    <meta property="og:image:height" content="675" />
                    <meta name="geo.position" content="22.3026;73.1812" />
                    <meta name="geo.placename" content="4th Floor - Office 1, 7, Sky Complex, Laxmipura, Vadodara, Gujarat 390021" />
                    <meta name="geo.region" content="IN-GJ" />
                    <meta property="og:latitude" content="22.3026" />
                    <meta property="og:longitude" content="73.1812" />
                    <meta property="og:location" content="4th Floor - Office 1, 7, Sky Complex, Laxmipura, Vadodara, Gujarat 390021" />

                    
                    <meta name="twitter:title" content="Lurantech | Services | Tailored IT Solutions for Your Success" />
                    <meta name="twitter:description" content="Lurantech offers top-quality IT services like Liferay CMS development, IT service management, cloud solutions, data engineering, and more. Tailored IT solutions for you." />
                    <meta name="twitter:image" content={`${server_url}${homeimg}`} />
                    <meta name="twitter:card" content="summary_large_image" />
                    <meta property="twitter:image:type" content="image/jpeg" />
                    <meta property="twitter:image:width" content="1200" />
                    <meta property="twitter:image:height" content="675" />

                    <meta name="robots" content="index, follow" />
                    <meta name="description" content="Lurantech offers top-quality IT services like Liferay CMS development, IT service management, cloud solutions, data engineering, and more. Tailored IT solutions for you." />
                    <meta name="keywords" content="Liferay CMS development, IT service management, cloud solutions, application development, data engineering, integration platforms, flexible cooperation, tailored IT solutions, e-commorce" />
                    <meta name="author" content="Lurantech" />

                    <link rel="canonical" href={`${server_url}/service`} />
                    <link rel="preload" href={`${server_url}${homeimg}`} as="image" />
                    <title>Lurantech | Services | Tailored IT Solutions for Your Success</title>
                </Helmet>

                <script
                    type="application/ld+json"
                    dangerouslySetInnerHTML={{
                        __html: JSON.stringify(schemaData),
                    }}
                />

                <TopBanner title="OUR SERVICES"  bgimage='/images/about-us/about.jpg'/>
                <RightImageText />
                <div className="row g-0 py-4">
                    <div className='text-center head-service-text'>
                        Featured Services
                    </div>
                </div>

                <BestSolutions />
                {/* <Solutions /> */}
                <div className="row g-0 py-4">
                    <div className='text-center head-service-text'>
                        Our Expertised Area
                    </div>
                </div>

                <div className="row g-0 logos-con">
                    <div className="col-1 col-sm-1 col-md-1 col-lg-1 col-xl-1 logos-div"></div>
                    <div className="col-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 logos-div">
                        <img data-tooltip-id="liferay" src="/images/service/liferay.png" alt="lurantech liferay" />
                        <ReactTooltip id="liferay" place="bottom" content="Liferay" />
                    </div>
                    <div className="col-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 logos-div">
                        <img data-tooltip-id="aws" src="/images/service/aws.svg" alt="lurantech aws" />
                        <ReactTooltip id="aws" place="bottom" content="Amazon Web Services" />
                    </div>
                    <div className="col-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 logos-div">
                        <img src="/images/service/tomcat.svg" alt="lurantech tomcat" data-tooltip-id="tomcat"   />
                        <ReactTooltip id="tomcat" place="bottom" content="Apache tomcat" />
                    </div>
                    <div className="col-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 logos-div">
                        <img src="/images/service/springboot.svg" alt="lurantech springboot" data-tooltip-id="springboot"   />
                        <ReactTooltip id="springboot" place="bottom" content="Java Spring-Boot" />
                    </div>
                    <div className="col-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 logos-div">
                        <img src="/images/service/dxpcloude.jpg" alt="lurantech dxp cloude"  data-tooltip-id="dxpcloude"  />
                        <ReactTooltip id="dxpcloude" place="bottom" content="Liferay DXP cloud" />
                    </div>
                    <div className="col-1 col-sm-1 col-md-1 col-lg-1 col-xl-1 logos-div"></div>
                    
                    <div className="col-1 col-sm-1 col-md-1 col-lg-1 col-xl-1 logos-div"></div>
                    <div className="col-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 logos-div">
                        <img src="/images/service/mysql.svg" alt="lurantech mysql" data-tooltip-id="mysql"   />
                        <ReactTooltip id="mysql" place="bottom" content="MySQL Database" />
                    </div>
                    <div className="col-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 logos-div">
                        <img src="/images/service/postgresql.svg" alt="lurantech postgre"  data-tooltip-id="postgre"  />
                        <ReactTooltip id="postgre" place="bottom" content="PostgreSQL Database" />
                    </div>
                    <div className="col-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 logos-div">
                        <img src="/images/service/mongodb.svg" alt="lurantech mongodb" data-tooltip-id="mongodb"   />
                        <ReactTooltip id="mongodb" place="bottom" content="MongoDB" />
                    </div>
                    <div className="col-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 logos-div">
                        <img src="/images/service/c.svg" alt="lurantech c++" data-tooltip-id="c"   />
                        <ReactTooltip id="c" place="bottom" content="C++" />
                    </div>
                    <div className="col-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 logos-div">
                        <img src="/images/service/java.svg" alt="lurantech java" data-tooltip-id="java"   />
                        <ReactTooltip id="java" place="bottom" content="Java Technologies" />
                    </div>
                    <div className="col-1 col-sm-1 col-md-1 col-lg-1 col-xl-1 logos-div"></div>

                    <div className="col-1 col-sm-1 col-md-1 col-lg-1 col-xl-1 logos-div"></div>
                    <div className="col-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 logos-div">
                        <img src="/images/service/gstreamer.png" alt="lurantech gstreamer" data-tooltip-id="gstreamer"  />
                        <ReactTooltip id="gstreamer" place="bottom" content="Gstreamer" />
                    </div>
                    <div className="col-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 logos-div">
                        <img src="/images/service/ffmpeg.png" alt="lurantech ffmpeg" data-tooltip-id="ffmpeg" />
                        <ReactTooltip id="ffmpeg" place="bottom" content="FFmpeg" />
                    </div>
                    <div className="col-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 logos-div">
                        <img src="/images/service/rust.svg" alt="lurantech rust"  data-tooltip-id="rust"  />
                        <ReactTooltip id="rust" place="bottom" content="Rust" />
                    </div>
                    <div className="col-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 logos-div">
                        <img src="/images/service/go.svg" alt="lurantech go" data-tooltip-id="go"   />
                        <ReactTooltip id="go" place="bottom" content="GoLang" />
                    </div>
                    <div className="col-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 logos-div">
                        <img src="/images/service/react.svg" alt="lurantech react"  data-tooltip-id="react"  />
                        <ReactTooltip id="react" place="bottom" content="React JS" />
                    </div>
                    <div className="col-1 col-sm-1 col-md-1 col-lg-1 col-xl-1 logos-div"></div>
                    <div className="col-1 col-sm-1 col-md-1 col-lg-1 col-xl-1 logos-div"></div>
                    <div className="col-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 logos-div">
                        <img src="/images/service/bootstrap.svg" alt="lurantech bootstrap" data-tooltip-id="bootstrap"   />
                        <ReactTooltip id="bootstrap" place="bottom" content="Bootstrap" />
                    </div>
                    <div className="col-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 logos-div">
                        <img src="/images/service/html.png" alt="lurantech html" data-tooltip-id="html"   />
                        <ReactTooltip id="html" place="bottom" content="HTML 5" />
                    </div>
                    <div className="col-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 logos-div">
                        <img src="/images/service/css.png" alt="lurantech css" data-tooltip-id="css"   />
                        <ReactTooltip id="css" place="bottom" content="CSS" />
                    </div>
                    <div className="col-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 logos-div">
                        <img src="/images/service/js.png" alt="lurantech js" data-tooltip-id="js"   />
                        <ReactTooltip id="js" place="bottom" content="Java Script" />
                    </div>
                    <div className="col-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 logos-div">
                        {/* <img src={bootstrap} alt="lurantech bootstrap"   /> */}
                    </div>
                    <div className="col-1 col-sm-1 col-md-1 col-lg-1 col-xl-1 logos-div"></div>
                    
                </div>

                <div className='why-our-container'>
                    <div className="row g-0">
                        <div className="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2"></div>
                        <div className="col-12 col-sm-8 col-md-8 col-lg-8 col-xl-8">
                            <div className="why-our-title">
                                Why Our Services are Better?
                            </div>
                        </div>
                        <div className="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2"></div>
                    </div>
                    <div className="row g-0 why-our-con-lower">
                        <Badge badgetitle="Quality Comes First" badgeimg="/images/about-us/quality-comes.png" />
                        <Badge badgetitle="Flexible Cooperation" badgeimg="/images/about-us/flexibal.png" />
                        <Badge badgetitle="On-time Delivery" badgeimg="/images/about-us/on-time.png" />
                        <Badge badgetitle="Qualified Developers" badgeimg="/images/about-us/qualified.png" />
                        <Badge badgetitle="Transparent Costs" badgeimg="/images/about-us/transparent.png" />
                        <Badge badgetitle="Quick Scale-up" badgeimg="/images/about-us/quick-scale.png" />
                    </div>
                </div>
            </HelmetProvider>
        </>
    )
};
